"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'graphicnavigation',
  props: {
    datas: Object
  },
  created: function created() {
    console.log(this.datas, '--------graphicnavigation');
  },
  data: function data() {
    return {
      resPath: process.env.VUE_APP_IMAGE_PATH || ''
    };
  }
};